import eventsCalloutSlider from '../../components/sliders/eventsCalloutSlider';
new eventsCalloutSlider(document.querySelector('[data-comp-events-callout-slider]'));
